var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDownloadIconWhite = function SvgArrowDownloadIconWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51339 9.35041L7.51309 9.35067C7.49642 9.36549 7.46367 9.38245 7.41346 9.38235L7.41125 9.38235C7.3623 9.38247 7.32931 9.36582 7.31188 9.35036L3.29027 5.78163C3.28596 5.7778 3.28327 5.77471 3.28171 5.77268C3.28313 5.77085 3.28557 5.76809 3.28945 5.76464L3.29001 5.76415L3.65351 5.44061C3.65356 5.44057 3.65361 5.44052 3.65366 5.44048C3.67191 5.42435 3.70305 5.40876 3.75053 5.40876C3.79634 5.40876 3.82587 5.4232 3.8455 5.44049C3.8456 5.44058 3.84569 5.44066 3.84579 5.44074L6.20952 7.54561L7.04203 8.28695L7.04203 7.1722L7.04203 0.545924C7.04389 0.543884 7.04664 0.541176 7.05061 0.537841C7.07253 0.519408 7.11428 0.5 7.16784 0.5L7.68419 0.5C7.73545 0.5 7.76516 0.517613 7.77699 0.52817C7.78064 0.531428 7.78257 0.533915 7.78347 0.535246L7.78347 7.14858L7.78347 8.25913L8.61493 7.52292L10.9663 5.4409L10.9669 5.4404C10.9809 5.42798 11.0173 5.40868 11.0709 5.40868C11.1204 5.40868 11.153 5.42545 11.1699 5.4404L11.17 5.44058L11.5351 5.76443C11.5392 5.76812 11.5418 5.7711 11.5434 5.77307C11.5419 5.77502 11.5393 5.77793 11.5352 5.78155L7.51339 9.35041ZM7.03862 0.550454C7.03857 0.550448 7.03877 0.550016 7.03937 0.549178L7.03862 0.550454Z",
    fill: "#009EBA",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 13,
    x2: 13.8235,
    y2: 13,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDownloadIconWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_download_icon_white.a71d83fd.svg";
export { ForwardRef as ReactComponent };